var exports = {
  "p": "x1cb7f6e3--5369e4--plain",
  "L": "x1cb7f6e3--5369e4--desktop",
};

module.exports = exports;
